import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
    Box, Typography, TextField, Button, Checkbox, FormControlLabel,
    Grid, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, IconButton, Autocomplete, Card, CardContent, Divider, MenuItem,
    Radio, Alert
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import Swal from 'sweetalert2';
import { db } from '../../firebase';
import { collection, addDoc, onSnapshot, query, where, updateDoc, doc, Timestamp, limit, getDocs, orderBy, writeBatch, getDoc, deleteDoc } from 'firebase/firestore';
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { storage } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { uploadBytesResumable } from "firebase/storage";
import { Document, Page, Text, View, StyleSheet, pdf } from "@react-pdf/renderer";
import MicIcon from '@mui/icons-material/Mic';
import { InputAdornment } from '@mui/material';
import moment from 'moment';

let port = null;
let reader = null;
let isReading = false;

const WeighbridgeSoftware = () => {
    const Toast = Swal.mixin({ toast: true, position: "top-end", showConfirmButton: false, timer: 4000, timerProgressBar: true, });
    const [isAuto, setIsAuto] = useState(true);
    const [liveWeight, setLiveWeight] = useState(0);
    const [manualWeight, setManualWeight] = useState(0);
    const [grossWeight, setGrossWeight] = useState(200);
    const [tareWeight, setTareWeight] = useState(100);
    const [netWeight, setNetWeight] = useState(100);

    // Dates
    const [grossDate, setGrossDate] = useState(moment().format('YYYY-MM-DD'));
    const [tareDate, setTareDate] = useState(moment().format('YYYY-MM-DD'));

    const [selectedTripId, setSelectedTripId] = useState(null);
    const [dailyCreditLimit, setdailyCreditLimit] = useState(0);
    const [monthcreditLimit, setmonthCreditLimit] = useState(0);
    const [remainingCredit, setRemainingCredit] = useState(0);
    const [usedCredit, setUsedCredit] = useState(0);

    // Outstanding Totals States
    const [overallTotalSale, setOverallTotalSale] = useState(0);
    const [overallTotalPaid, setOverallTotalPaid] = useState(0);
    const [overallOutstanding, setOverallOutstanding] = useState(0);

    const vehicleRef = useRef(null);
    const customerRef = useRef(null);
    const videoRef1 = useRef(null);
    const videoRef2 = useRef(null);
    const videoRef3 = useRef(null);
    const [isCaptured, setIsCaptured] = useState(false);
    const [weightType, setWeightType] = useState("tare");
    const [whatsapp, setwhatsapp] = useState("Yes");
    const [deleteOtp, setDeleteOtp] = useState("");
    const [generatedOtp, setGeneratedOtp] = useState("");
    const [otpDialogOpen, setOtpDialogOpen] = useState(false);
    const [deleteRowId, setDeleteRowId] = useState(null);
    const grossRadioRef = React.useRef(null);
    const tareRadioRef = React.useRef(null);
    const [resetKey, setResetKey] = useState(0);
    const [printData, setPrintData] = useState(null);
    const [pendingAutoAction, setPendingAutoAction] = useState("");
    const [throughDetails, setThroughDetails] = useState([]);

    const [autoOtpDialog, setAutoOtpDialog] = useState(false);
    const [autoOtp, setAutoOtp] = useState("");
    const [generatedAutoOtp, setGeneratedAutoOtp] = useState("");
    const [autoUnlocked, setAutoUnlocked] = useState(false);

    const [productRows, setProductRows] = useState([{ productId: '', productName: '', qty: "", rate: "", amount: 0 }]);
    const [openProductDialog, setOpenProductDialog] = useState(false);
    const [tempProduct, setTempProduct] = useState({ productId: "", productName: "", qty: "", rate: "", amount: 0 });

    const [payments, setPayments] = useState([
        { amount: "", paymentMode: "", note: "", date: new Date().toISOString().split("T")[0] },
        { amount: "", paymentMode: "", note: "", date: new Date().toISOString().split("T")[0] }
    ]);

    const [formData, setFormData] = useState({
        customerId: '',
        customerName: '',
        vehicleNo: '',
        challan: '',
        mobile: '',
        location: '',
        wbName: 'Vishwajeet Khadi Kendra Bridge',
        ticketNo: '',
        paymentMode: '',
        type: "Sale",
        invoice: "No",
        throughId: "",
        throughName: ""
    });

    const [customers, setCustomers] = useState([]);
    const [products, setProducts] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [paymentModes, setPaymentModes] = useState([]);
    const [pendingTransactions, setPendingTransactions] = useState([]);

    // --- Data Fetching ---
    useEffect(() => {
        const q = query(collection(db, "customers"), orderBy("customerName", "asc"));
        onSnapshot(q, (s) => {
            const allData = s.docs.map(d => ({
                id: d.id,
                customerName: d.data().customerName?.trim().toUpperCase() || "",
                mobile: d.data().mobile || "",
                location: d.data().city || "",
                dailyCreditLimit: d.data().dailyCreditLimit,
                monthlyCreditLimit: d.data().monthlyCreditLimit,
                products: d.data().products || []
            }));
            const uniqueCustomers = Array.from(new Map(allData.map(item => [item.customerName, item])).values());
            setCustomers(uniqueCustomers);
        });

        onSnapshot(collection(db, "trip_products"), (s) => {
            setProducts(s.docs.map(d => ({
                id: d.id,
                name: d.data().productName,
                tripType: d.data().tripType,
                rate: d.data().rate || 0,
            })));
        });

        onSnapshot(collection(db, "vehicles"), (s) => {
            setVehicles(s.docs.map(d => d.data().vehicalNo || ""));
        });

        onSnapshot(collection(db, "payment_modes"), (s) => {
            setPaymentModes(s.docs.map(d => d.data().payMode || ""));
        });

        onSnapshot(collection(db, "throughdetails"), (snapshot) => {
            setThroughDetails(
                snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }))
            );
        });
    }, []);

    useEffect(() => {
        const q = query(collection(db, "trips"), where("status", "==", "Pending"), orderBy('createdAt', 'asc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            setPendingTransactions(data);
        });
        return () => unsubscribe();
    }, []);

    // --- Fetch Next Numbers ONLY on Mount ---
    useEffect(() => {
        const fetchInitialNumbers = async () => {
            try {
                // Fetch the absolute latest trip by creation date
                const latestTripQ = query(collection(db, "trips"), orderBy("createdAt", "desc"), limit(1));
                const latestSnap = await getDocs(latestTripQ);

                let nextTicketNo = 1;
                let nextChallanNo = 1;

                if (!latestSnap.empty) {
                    const lastTrip = latestSnap.docs[0].data();

                    // Extract and increment the numbers from the single latest document
                    nextTicketNo = (Number(lastTrip.ticketNo) || 0) + 1;
                    nextChallanNo = (Number(lastTrip.challan) || 0) + 1;
                }

                setFormData((prev) => ({
                    ...prev,
                    ticketNo: nextTicketNo,
                    challan: nextChallanNo
                }));

            } catch (error) {
                console.error("Error fetching initial numbers:", error);
            }
        };

        fetchInitialNumbers();
    }, []);

    // --- Computations ---
    useEffect(() => {
        const net = Math.max(0, (grossWeight || 0) - (tareWeight || 0));
        setNetWeight(net);
    }, [grossWeight, tareWeight]);

    useEffect(() => {
        const qty = Number(formData.brass || 0);
        const rate = Number(formData.rate || 0);
        setFormData(prev => ({ ...prev, amount: qty * rate }));
    }, [formData.brass, formData.rate]);

    const totalSale = productRows.reduce((sum, row) => sum + row.amount, 0);

    // --- Handlers ---
    const handlePopupProduct = (value) => {
        const prod = products.find(p => p.name === value);
        setTempProduct({
            productId: prod?.id || "", productName: value, qty: 0, rate: prod?.rate || 0, amount: 0
        });
    };

    const handleTempChange = (field, value) => {
        setTempProduct(prev => {
            const newData = { ...prev, [field]: value };
            const qty = parseFloat(newData.qty) || 0;
            const rate = parseFloat(newData.rate) || 0;
            const extra = parseFloat(newData.extraAmount) || 0;
            newData.amount = (qty * rate) + extra;
            return newData;
        });
    };

    const addProductFromPopup = () => {
        if (!tempProduct.productName || tempProduct.qty <= 0) {
            Alert.alert("Error", "Please select a product and quantity");
            return;
        }

        const newRow = {
            productId: tempProduct.productId, productName: tempProduct.productName,
            qty: parseFloat(tempProduct.qty), rate: parseFloat(tempProduct.rate),
            extraLabel: tempProduct.extraLabel || "", extraAmount: parseFloat(tempProduct.extraAmount) || 0,
            amount: parseFloat(tempProduct.amount),
        };

        setProductRows([...productRows, newRow]);
        setOpenProductDialog(false);
        setTempProduct({ qty: 0, rate: 0, amount: 0, extraAmount: 0, extraLabel: "" });
    };

    const handleProductChange = (index, value) => {
        const prod = products.find(p => p.name === value);
        let rate = 0;
        const selectedCustomer = customers.find(c => c.id === formData.customerId);

        if (selectedCustomer && selectedCustomer.products) {
            const custProd = selectedCustomer.products.find(p => p.productName === value);
            rate = custProd ? custProd.rate : (prod?.rate || 0);
        } else {
            rate = prod?.rate || 0;
        }

        const rows = [...productRows];
        rows[index].productId = prod?.id || '';
        rows[index].productName = value;
        rows[index].rate = rate;
        rows[index].amount = Math.round((rows[index].qty || 0) * rate);
        setProductRows(rows);
        setFormData(prev => ({ ...prev, type: prod?.tripType || "Sale" }));
    };

    const handleRowChange = (index, field, value) => {
        const rows = [...productRows];
        rows[index][field] = Number(value);
        rows[index].amount = Math.round(rows[index].qty * rows[index].rate);
        setProductRows(rows);
    };

    const handleCapture = async () => {
        if (isCaptured) return;
        setIsCaptured(true);
        const currentWeight = isAuto ? liveWeight : manualWeight;

        try {
            if (weightType === "tare") {
                setTareWeight(currentWeight);
                setTareDate(new Date());
                setFormData(prev => ({ ...prev, tareWeight: currentWeight }));
                if (selectedTripId) {
                    await updateDoc(doc(db, "trips", selectedTripId), { tarePhotos: "tarePhotoUrls" });
                }
            } else if (weightType === "gross") {
                setGrossWeight(currentWeight);
                setGrossDate(new Date());
                setFormData(prev => ({ ...prev, grossWeight: currentWeight }));
                setNetWeight(Math.max(0, currentWeight - (tareWeight || 0)));
                if (selectedTripId) {
                    await updateDoc(doc(db, "trips", selectedTripId), { grossPhotos: "grossPhotoUrls" });
                }
                customerRef.current?.focus();
            }
        } catch (error) {
            Swal.fire("Error", "Capture failed", "error");
        }
        setIsCaptured(false);
    };

    const handleProcess = async () => {
        try {
            if (!formData.vehicleNo) return Swal.fire("Error", "Vehicle number required", "error");
            if (!formData.customerName) return Swal.fire("Error", "Customer name required", "error");

            const [customer] = await Promise.all([getOrCreateCustomer(formData)]);
            const now = Timestamp.now();

            const baseData = {
                ...formData,
                customerId: customer.id,
                customerName: customer.data.customerName,
                vehicleId: formData.vehicleNo,
                products: productRows,
                totalAmount: totalSale,
                throughId: formData.throughId || "",
                throughName: formData.throughName || "",
                tareWeight: formData.tareWeight || 0,
                grossWeight: formData.grossWeight || 0,
                challan: Number(formData.challan) || 0
            };

            const paid = payments.reduce((sum, p) => sum + Number(p.amount || 0), 0);
            const remaining = totalSale - paid;

            // ✅ CALCULATE NEW OVERALL TOTALS FOR WHATSAPP
            const currentOverallSale = overallTotalSale + totalSale;
            const currentOverallPaid = overallTotalPaid + paid;
            const currentOverallOutstanding = currentOverallSale - currentOverallPaid;

            let newData = {
                ...baseData,
                status: "Completed",
                createdAt: now,
                paidAmount: paid,
                remainingAmount: remaining,
                grossDate: Timestamp.fromDate(new Date(grossDate)),
                tareDate: Timestamp.fromDate(new Date(tareDate)),
            };

            let savedTicket = formData.ticketNo;

            if (selectedTripId) {
                await updateDoc(doc(db, "trips", selectedTripId), newData);
            } else {
                const tripDocRef = await addDoc(collection(db, "trips"), newData);

                if (paid > 0) {
                    const newPaymentEntries = payments
                        .filter(p => Number(p.amount) > 0)
                        .map(p => ({
                            amount: Number(p.amount),
                            mode: p.paymentMode || "Cash",
                            note: p.note || "",
                            date: p.date ? Timestamp.fromDate(new Date(p.date)) : now,
                        }));

                    for (const payment of newPaymentEntries) {
                        await addDoc(collection(db, "customer_history"), {
                            customerId: customer.id, amount: payment.amount, paymentMode: payment.mode,
                            note: payment.note, date: payment.date, tripId: tripDocRef.id,
                            type: "Trip", createdAt: now
                        });
                    }
                }
            }

            const downloadURL = formData.downloadURL || "";

            // ✅ PASS THE NEW VARIABLES TO WHATSAPP FUNCTION
            await sendWhatsAppMessage(
                formData.mobile,
                downloadURL,
                customer.data.customerName,
                savedTicket,
                totalSale,                 // Current Trip Amount
                productRows,
                currentOverallPaid,        // Overall Paid ({{7}})
                currentOverallOutstanding, // Overall Outstanding ({{8}})
                formData.vehicleNo,
                grossDate,
                currentOverallSale         // Overall Sale ({{6}})
            );

            Swal.fire("Success", `Trip Successfully ${selectedTripId ? "Updated" : "Added"}`, "success");

            const lastSavedChallan = formData.challan;
            const lastSavedTicket = formData.ticketNo;

            if (typeof setSelectedTripId === "function") setSelectedTripId(null);

            clearForm(lastSavedChallan, lastSavedTicket);
            setIsCaptured(false);

        } catch (e) {
            setIsCaptured(false);
            Swal.fire("Error", "Transaction failed: " + e.message, "error");
        }
    };


    const getOrCreateCustomer = async (formData) => {
        const customersRef = collection(db, "customers");
        let q = query(customersRef, where("customerName", "==", formData.customerName));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
            const docSnap = snapshot.docs[0];
            return { id: docSnap.id, data: docSnap.data() };
        }

        const newCustomer = {
            customerName: formData.customerName || "", mobile: formData.mobile || "",
            address: formData.location || "", city: formData.location || "", createdAt: Timestamp.now(),
        };

        const docRef = await addDoc(customersRef, newCustomer);
        handlePartySelect({ id: docRef.id, ...newCustomer });
        return { id: docRef.id, data: newCustomer };
    };

    const handlePartySelect = async (cust) => {
        if (!cust) {
            setOverallTotalSale(0);
            setOverallTotalPaid(0);
            setOverallOutstanding(0);
            return;
        }

        setFormData(prev => ({
            ...prev,
            customerId: cust.id,
            customerName: cust.customerName,
            mobile: cust.mobile || prev.mobile,
            location: cust.location || prev.location
        }));

        setdailyCreditLimit(cust.dailyCreditLimit || 0);
        setmonthCreditLimit(cust.monthlyCreditLimit || 0);
        await calculateCustomerCredit(cust.id, cust.dailyCreditLimit);
    };

    const calculateCustomerCredit = async (custId, limit) => {
        const now = new Date();
        const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        // Daily limit calculation
        const tripQuery = query(collection(db, "trips"), where("customerId", "==", custId), where("grossDate", ">=", startOfToday));
        const tripSnap = await getDocs(tripQuery);
        let todaySale = 0;
        tripSnap.forEach(doc => {
            todaySale += doc.data().products?.reduce((sum, p) => sum + Number(p.amount || 0), 0) || 0;
        });

        // --- Fetch ALL trips for overall total ---
        const allTripsQuery = query(collection(db, "trips"), where("customerId", "==", custId));
        const allTripsSnap = await getDocs(allTripsQuery);
        let overallSale = 0;
        allTripsSnap.forEach(doc => {
            overallSale += doc.data().products?.reduce((sum, p) => sum + Number(p.amount || 0), 0) || 0;
        });

        // --- Fetch ALL payments for overall paid ---
        const allPayQuery = query(collection(db, "customer_history"), where("customerId", "==", custId));
        const allPaySnap = await getDocs(allPayQuery);
        let overallPaid = 0;
        let todayPaid = 0;
        allPaySnap.forEach(doc => {
            const amt = Number(doc.data().amount || 0);
            overallPaid += amt;
            // Rough filter for today's payment logic if needed for limit warning
            const dateStr = doc.data().date;
        });

        const outstanding = overallSale - overallPaid;

        setOverallTotalSale(overallSale);
        setOverallTotalPaid(overallPaid);
        setOverallOutstanding(outstanding);

        // Alert logic for daily limit if needed
        const used = todaySale; // Assuming limit applies to daily sale
        const remaining = (limit || 0) - used;

        if (limit > 0 && remaining < 0) {
            Swal.fire({
                title: "🚫 Credit Limit Exceeded",
                html: `<b style="color:red">Limit Exceeded!</b><br/><br/>`,
                icon: "error"
            });
        }
    };

    const clearForm = (lastSavedChallan = null, lastSavedTicket = null) => {
        setIsCaptured(false);
        setFormData(prev => ({
            ...prev,
            customerId: "",
            customerName: "",
            vehicleNo: "",
            mobile: "",
            location: "",
            throughId: "",
            throughName: "",
            // Simply increment by 1 from the last saved state!
            challan: lastSavedChallan ? String(Number(lastSavedChallan) + 1) : prev.challan,
            ticketNo: lastSavedTicket ? String(Number(lastSavedTicket) + 1) : prev.ticketNo,
        }));

        setOverallTotalSale(0);
        setOverallTotalPaid(0);
        setOverallOutstanding(0);

        setProductRows([{ productId: "", productName: "", qty: 0, rate: 0, amount: 0 }]);
        setSelectedTripId(null);
        setManualWeight(0);
        setGrossWeight(0);
        setTareWeight(0);

        setPayments([
            { amount: "", paymentMode: "", note: "", date: new Date().toISOString().split("T")[0] },
            { amount: "", paymentMode: "", note: "", date: new Date().toISOString().split("T")[0] }
        ]);

        setResetKey(prev => prev + 1);
    };

    const sendWhatsAppMessage = async (
        mobile, downloadURL, customerName, invoiceNo, amount, products = [],
        overallPaid = 0, overallOutstanding = 0, vehicalNo, tripDate, overallSale = 0
    ) => {
        try {
            const phoneid = "1207419932457509";
            const accesstoken = "EAAKj5T0Mx1YBRNd6VhhufPP2ApIjZCsZBFOkl855np9VZBvPvZAZAj7axVAevZBiapxd1Iw38v0hhZBwB2knNeLYSVgjR3RqtPn164H2GQ3ljP46kQvAAq0gsl3lfKDh55ZCsmo5fGZCaUSPpCRqeFjVA6VUeIaiu0ZCNxPPMTsV4oxnnUz4TRoICdbiW0xsAncwZDZD";

            const productNames = products.map((p, i) => `${i + 1}) ${p.productName}`).join(" / ");
            const formattedDate = moment(tripDate).format("DD/MM/YYYY");
            const cleanMobile = String(mobile || "").replace(/\D/g, "");

            const payload = {
                messaging_product: "whatsapp", to: "91" + cleanMobile, type: "template",
                template: {
                    name: "all_totalinvoice", language: { code: "en" },
                    components: [{
                        type: "body",
                        parameters: [
                            { type: "text", text: String(customerName || "Customer").trim() },          // {{1}}
                            { type: "text", text: String(productNames || "-").trim() },                 // {{2}}
                            { type: "text", text: String(amount || 0).trim() },                         // {{3}}
                            { type: "text", text: String(formattedDate).trim() },                       // {{4}}
                            { type: "text", text: String(vehicalNo || "N/A").trim() },                  // {{5}}
                            { type: "text", text: String(overallSale || 0).trim() },                    // {{6}}
                            { type: "text", text: String(overallPaid || 0).trim() },                    // {{7}}
                            { type: "text", text: String(overallOutstanding || 0).trim() }              // {{8}}
                        ]
                    }]
                }
            };

            const response = await fetch(`https://graph.facebook.com/v22.0/${phoneid}/messages`, {
                method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${accesstoken}` },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
            if (response.ok) {
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, customerName, invoiceNo, type: "Trip Invoice", amount, fileURL: downloadURL, status: "Sent", createdAt: Timestamp.now() });
                Toast.fire({ icon: "success", title: "WhatsApp Invoice Sent" });
            } else {
                await addDoc(collection(db, "whatsapp_history"),
                    { mobile, customerName, invoiceNo, type: "Trip Invoice", amount, fileURL: downloadURL, status: "Failed", error: data.error?.message, createdAt: Timestamp.now() });
            }
        } catch (error) {
            console.error("❌ Fetch Error:", error);
        }
    };

    const fetchTripByTicket = async (ticketNo) => {
        if (!ticketNo) return;
        const q = query(collection(db, "trips"), where("ticketNo", "==", Number(ticketNo)));
        const snapshot = await getDocs(q);

        if (snapshot.empty) return Swal.fire("Not Found", "No trip found for this ticket", "warning");

        const row = { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
        setSelectedTripId(row.id);
        populateFormFromRow(row);
    };

    const fetchTripByChalan = async (challanNo) => {
        if (!challanNo) return;
        const q = query(collection(db, "trips"), where("challan", "==", Number(challanNo)));
        const snapshot = await getDocs(q);

        if (snapshot.empty) return Swal.fire("Not Found", "No trip found for this challan", "warning");

        const row = { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
        setSelectedTripId(row.id);
        populateFormFromRow(row);
    };

    const populateFormFromRow = (row) => {
        setFormData({
            customerId: row.customerId || "", customerName: row.customerName || "",
            vehicleNo: row.vehicleNo || "", product: row.product || "",
            challan: row.challan || "", brass: row.brass || "", rate: row.rate || 0,
            amount: row.amount || 0, mobile: row.mobile || "", location: row.location || "",
            wbName: row.wbName || "Vishwajeet Khadi Kendra Bridge", ticketNo: row.ticketNo || "",
            paymentMode: row.paymentMode || "", throughId: row.throughId || "", throughName: row.throughName || ""
        });

        if (row.customerId) {
            const cust = customers.find(c => c.id === row.customerId);
            if (cust) {
                setdailyCreditLimit(cust.dailyCreditLimit || 0);
                calculateCustomerCredit(cust.id, cust.dailyCreditLimit);
            } else {
                calculateCustomerCredit(row.customerId, 0);
            }
        }

        setProductRows(row.products?.length > 0 ? row.products : [{ productId: "", productName: "", qty: 0, rate: 0, amount: 0 }]);
        setTareWeight(row.tareWeight || 0);
        setGrossWeight(row.grossWeight || 0);
        setTareDate(row.tareDate ? moment(row.tareDate.toDate()).format('YYYY-MM-DD') : null);
        setGrossDate(row.grossDate ? moment(row.grossDate.toDate()).format('YYYY-MM-DD') : null);

        setPayments(row.payments?.length > 0 ? row.payments.map(payment => ({
            amount: payment.amount || "", paymentMode: payment.mode || "", note: payment.note || "",
            date: payment.date ? new Date(payment.date.seconds * 1000).toISOString().split("T")[0] : new Date().toISOString().split("T")[0]
        })) : [
            { amount: row.paidAmount || "", paymentMode: row.paymentMode || "", note: row.paymentNote || "", date: row.paymentDate ? new Date(row.paymentDate.seconds * 1000).toISOString().split("T")[0] : new Date().toISOString().split("T")[0] },
            { amount: "", paymentMode: "", note: "", date: new Date().toISOString().split("T")[0] }
        ]);
    };

    const handlePrintTicket = async () => {
        if (!formData.ticketNo) return Swal.fire("Error", "Please enter a Ticket Number", "error");

        try {
            const q = query(collection(db, "trips"), where("ticketNo", "==", Number(formData.ticketNo)));
            const querySnapshot = await getDocs(q);
            if (querySnapshot.empty) return Swal.fire("Not Found", "No trip found with this Ticket Number", "warning");

            setPrintData(querySnapshot.docs[0].data());
            setTimeout(() => { window.print(); setPrintData(null); }, 500);
        } catch (error) {
            Swal.fire("Error", "Failed to fetch print data", "error");
        }
    };

    const handleGrossDateChange = (e) => {
        const newDate = e.target.value;
        setGrossDate(newDate);
        setTareDate(newDate);
    };

    return (
        <Box
            sx={{
                bgcolor: '#f4f6f8',
                height: '90vh',
                overflowY: 'hidden',
                overflowX: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                "& .MuiInputBase-root": { fontSize: "14px" },
                "& .MuiTableCell-root": { fontSize: "13px", padding: "6px 6px" },
                "& .MuiButton-root": { fontSize: "11px", padding: "4px 8px" }
            }}
        >
            <Grid className="row" sx={{ m: 0, width: '100%' }}>
                <Grid className="col-sm-3" sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Paper elevation={3} sx={{ p: 2, flex: 1, display: 'flex', flexDirection: 'column' }}>

                        <Box sx={{
                            bgcolor: 'black', color: '#ff1744', textAlign: 'center', fontSize: '3.5rem',
                            fontWeight: 'bold', fontFamily: 'monospace', borderRadius: 2, mb: 2, border: '2px solid #333',
                        }}>
                            {isAuto ? liveWeight : (
                                <TextField variant="standard" type="number" value={manualWeight} onChange={(e) => setManualWeight(Number(e.target.value))} inputProps={{ style: { color: '#ff1744', fontSize: '3rem', textAlign: 'center', fontFamily: 'monospace' } }} InputProps={{ disableUnderline: true }} />
                            )}
                        </Box>

                        <Button fullWidth variant="contained" color="secondary" onClick={handleCapture} disabled={isCaptured}>
                            Capture {weightType === "tare" ? "Tare" : "Gross"}
                        </Button>

                        <Card sx={{ mb: 1, borderRadius: 2, boxShadow: 4, mt: 1 }}>
                            <CardContent>
                                <Grid className="row" spacing={1} >
                                    <Grid className="col-sm-5 mb-2">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>WB Name</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={formData.wbName} onChange={(e) => setFormData({ ...formData, wbName: e.target.value })} />
                                    </Grid>
                                    <Grid className="col-sm-5">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Ticket No</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7">
                                        <TextField
                                            fullWidth size="small" type="number" value={formData.ticketNo}
                                            onChange={(e) => setFormData({ ...formData, ticketNo: e.target.value })}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") fetchTripByTicket(formData.ticketNo);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        <Box display="flex" flexDirection="column" gap={1.5}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" p={1} px={2} bgcolor="#e3f2fd" borderRadius={1} >
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1565c0' }}>Gross Date</Typography>
                                <TextField type="date" variant="standard" size="small"
                                    value={grossDate} onChange={handleGrossDateChange}
                                    InputProps={{ disableUnderline: true }}
                                    inputProps={{ style: { textAlign: 'right', fontWeight: 600, color: '#0d47a1', cursor: 'pointer' } }}
                                    sx={{ maxWidth: 150 }}
                                />
                            </Box>

                            <Box display="flex" justifyContent="space-between" alignItems="center" p={1} px={2} bgcolor="#fce4ec" borderRadius={1} >
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#c2185b' }}>Tare Date</Typography>
                                <TextField type="date" variant="standard" size="small"
                                    value={tareDate} onChange={(e) => setTareDate(e.target.value)}
                                    InputProps={{ disableUnderline: true }}
                                    inputProps={{ style: { textAlign: 'right', fontWeight: 600, color: '#880e4f', cursor: 'pointer' } }}
                                    sx={{ maxWidth: 150 }}
                                />
                            </Box>
                        </Box>

                        <Card sx={{ mb: 1, borderRadius: 2, boxShadow: 4 }}>
                            <CardContent>
                                <Grid className="row" spacing={1} >
                                    <Grid className="col-sm-5 mb-2">
                                        <FormControlLabel control={<Radio checked={weightType === "gross"} onChange={() => setWeightType("gross")} />} label="Gross " disabled={grossWeight > 0} />
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={grossWeight} disabled onChange={(e) => setGrossWeight(Number(e.target.value))} />
                                    </Grid>
                                    <Grid className="col-sm-5 mb-2">
                                        <FormControlLabel control={<Radio checked={weightType === "tare"} onChange={() => setWeightType("tare")} />} label="Tare" disabled={tareWeight > 0} />
                                    </Grid>
                                    <Grid className="col-sm-7 mb-2">
                                        <TextField fullWidth size="small" value={tareWeight} disabled onChange={(e) => setTareWeight(Number(e.target.value))} />
                                    </Grid>
                                    <Grid className="col-sm-5 ">
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>Net Weight</Typography>
                                    </Grid>
                                    <Grid className="col-sm-7 ">
                                        <TextField fullWidth size="small" value={netWeight} disabled />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Paper>
                </Grid>

                <Grid className="col-sm-9" sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Paper elevation={3} sx={{ p: 2, flex: 1, borderRadius: 2 }}>

                        {/* CUSTOMER TOTALS DASHBOARD */}
                        {formData.customerId && (
                            <Box sx={{ p: 1.5, bgcolor: "#fff3e0", borderRadius: 2, mb: 2, display: 'flex', justifyContent: 'space-between', border: '1px solid #ffe0b2' }}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#e65100' }}>
                                    Overall Total Sale: ₹{Number(overallTotalSale).toLocaleString("en-IN")}
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                                    Overall Total Paid: ₹{Number(overallTotalPaid).toLocaleString("en-IN")}
                                </Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: overallOutstanding > 0 ? '#d32f2f' : '#2e7d32' }}>
                                    Outstanding: ₹{Number(overallOutstanding).toLocaleString("en-IN")}
                                </Typography>
                            </Box>
                        )}

                        <Grid className="row">
                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Customer</Typography>
                                <Autocomplete
                                    key={`customer-${resetKey}`}
                                    freeSolo size="small"
                                    options={customers.map(c => ({ label: c.customerName, ...c }))}
                                    value={customers.map(c => ({ label: c.customerName, ...c })).find(c => c.customerName === formData.customerName) || formData.customerName || null}
                                    getOptionLabel={(option) => typeof option === "string" ? option : option.customerName || ""}
                                    filterOptions={(options, { inputValue }) => {
                                        const search = inputValue.toLowerCase().trim();
                                        if (!search) return options;
                                        return options.filter((opt) => (opt.customerName || "").toString().toLowerCase().trim().startsWith(search));
                                    }}
                                    onChange={(e, val) => {
                                        if (val && typeof val !== "string") { handlePartySelect(val); }
                                        else if (typeof val === "string") { setFormData(prev => ({ ...prev, customerName: val.toUpperCase() })); }
                                        else { setFormData(prev => ({ ...prev, customerName: "" })); }
                                    }}
                                    onInputChange={(e, val, reason) => { if (reason === "input") setFormData(prev => ({ ...prev, customerName: val.toUpperCase() })); }}
                                    renderInput={(params) => <TextField {...params} label="Customer Name" fullWidth />}
                                />
                            </Grid>
                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Vehicle No</Typography>
                                <Autocomplete
                                    freeSolo size="small" options={vehicles} value={formData.vehicleNo || ""}
                                    onChange={(e, val) => setFormData({ ...formData, vehicleNo: val || "" })}
                                    onInputChange={(e, val) => setFormData({ ...formData, vehicleNo: val })}
                                    renderInput={(params) => <TextField {...params} label="Vehicle Number" fullWidth />}
                                />
                            </Grid>

                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Product</Typography>
                                <Autocomplete
                                    size="small" options={products.map(p => p.name)} value={productRows[0]?.productName || ""}
                                    onChange={(e, val) => handleProductChange(0, val)}
                                    renderInput={(params) => <TextField {...params} label="Select Product" fullWidth />}
                                />
                            </Grid>
                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Challan</Typography>
                                <TextField
                                    size="small" fullWidth type="number" label="Challan No" value={formData.challan}
                                    onChange={(e) => setFormData({ ...formData, challan: e.target.value })}
                                    onKeyDown={(e) => { if (e.key === "Enter") fetchTripByChalan(formData.challan); }}
                                />
                            </Grid>

                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Brass</Typography>
                                <TextField size="small" type="number" fullWidth label="Quantity" value={productRows[0]?.qty} onChange={(e) => handleRowChange(0, "qty", e.target.value)} />
                            </Grid>
                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Rate</Typography>
                                <TextField size="small" type="number" fullWidth label="Rate per Brass" value={productRows[0]?.rate} onChange={(e) => handleRowChange(0, "rate", e.target.value)} />
                            </Grid>

                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Amount</Typography>
                                <TextField size="small" fullWidth disabled label="Calculated Amount" value={productRows[0]?.amount} />
                            </Grid>
                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Mobile</Typography>
                                <TextField size="small" fullWidth label="Mobile Number" value={formData.mobile} onChange={(e) => setFormData({ ...formData, mobile: e.target.value })} />
                            </Grid>

                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Location</Typography>
                                <TextField size="small" fullWidth label="Location Details" value={formData.location} onChange={(e) => setFormData({ ...formData, location: e.target.value })} />
                            </Grid>
                            <Grid className="col-sm-4 mb-2" item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.8, color: '#333' }}>Through</Typography>
                                <TextField
                                    select fullWidth size="small" label="Select Intermediary" value={formData.throughId || ""}
                                    onChange={(e) => {
                                        const selected = throughDetails.find(item => item.id === e.target.value);
                                        setFormData(prev => ({ ...prev, throughId: selected?.id || "", throughName: selected?.name || "" }));
                                    }}
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {throughDetails.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>

                        {productRows.slice(1).map((row, index) => (
                            <Box key={index} sx={{ border: "1px solid #e0e0e0", p: 2, borderRadius: 1.5, mt: 2, bgcolor: '#fafafa' }}>
                                <Typography variant="subtitle2" fontWeight="bold" color="primary" sx={{ mb: 1 }}>{row.productName}</Typography>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography variant="caption" color="textSecondary" display="block">Qty</Typography>
                                        <Typography variant="body2" fontWeight="500">{row.qty}</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="caption" color="textSecondary" display="block">Rate</Typography>
                                        <Typography variant="body2" fontWeight="500">₹{row.rate}</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant="caption" color="textSecondary" display="block">Amount</Typography>
                                        <Typography variant="body2" fontWeight="600">₹{row.amount}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        ))}

                        <Box mt={1} p={1} bgcolor="#e8f5e9" borderRadius={2}>
                            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#1b5e20' }}>Payment Details</Typography>
                            {payments.map((payment, index) => (
                                <Grid className="row" spacing={2} key={index} sx={{ mb: 1 }}>
                                    <Grid className="col-sm-4 mb-2" item xs={12} sm={4}>
                                        <TextField label={`Amount ${index + 1}`} size="small" fullWidth type="number" value={payment.amount}
                                            onChange={(e) => {
                                                const updated = [...payments];
                                                updated[index].amount = e.target.value;
                                                setPayments(updated);
                                            }}
                                        />
                                    </Grid>
                                    <Grid className="col-sm-4 mb-2" item xs={12} sm={4}>
                                        <TextField select label="Payment Mode" size="small" fullWidth value={payment.paymentMode}
                                            onChange={(e) => {
                                                const updated = [...payments];
                                                updated[index].paymentMode = e.target.value;
                                                setPayments(updated);
                                            }}
                                        >
                                            {paymentModes.map((mode, i) => <MenuItem key={i} value={mode}>{mode}</MenuItem>)}
                                        </TextField>
                                    </Grid>
                                    <Grid className="col-sm-4 mb-2" item xs={12} sm={4}>
                                        <TextField type="date" label="Payment Date" size="small" fullWidth disabled InputLabelProps={{ shrink: true }} value={payment.date} />
                                    </Grid>
                                </Grid>
                            ))}
                        </Box>

                        <Box display="flex" flexWrap="wrap" gap={2} mt={1}>
                            <Button variant="contained" color="success" onClick={handleProcess} startIcon={<RefreshIcon />}
                                sx={{ flex: 1, minWidth: '120px', py: 1, borderRadius: 1.5, fontWeight: 'bold' }}
                            >
                                {selectedTripId ? "Update" : "Save "}
                            </Button>
                            <Button variant="contained" color="error" onClick={() => clearForm()} startIcon={<CancelIcon />}
                                sx={{ flex: 1, minWidth: '120px', py: 1, borderRadius: 1.5, fontWeight: 'bold' }}
                            >
                                Cancel
                            </Button>
                            <Button variant="outlined" onClick={handlePrintTicket} startIcon={<PrintIcon />}
                                sx={{ flex: 1, minWidth: '120px', py: 1, borderRadius: 1.5, fontWeight: 'bold' }}
                            >
                                Print
                            </Button>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mt={1} pt={2} sx={{ borderTop: '1px dashed #ccc' }}>
                            <Button variant="outlined" size="medium" startIcon={<span>➕</span>} onClick={() => setOpenProductDialog(true)} sx={{ borderRadius: 1.5, fontWeight: 500 }}>
                                Add Product
                            </Button>
                            <Typography sx={{ fontWeight: "800", fontSize: "1.6rem", color: '#2e7d32' }}>
                                Total Sale : ₹ {totalSale}
                            </Typography>
                        </Box>

                    </Paper>
                </Grid>
            </Grid>

            <Dialog open={openProductDialog} onClose={() => setOpenProductDialog(false)} fullWidth maxWidth="xs">
                <DialogTitle>Add Product</DialogTitle>
                <DialogContent>
                    <Autocomplete
                        size="small" sx={{ mt: 1 }} options={products.map(p => p.name)} value={tempProduct.productName || ""}
                        onChange={(e, v) => handlePopupProduct(v)} renderInput={(params) => <TextField {...params} label="Product" />}
                    />
                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <TextField label="Qty" size="small" type="number" value={tempProduct.qty} onChange={(e) => handleTempChange("qty", e.target.value)} />
                        <TextField label="Rate" size="small" type="number" value={tempProduct.rate} onChange={(e) => handleTempChange("rate", e.target.value)} />
                    </Box>
                    <Typography variant="caption" sx={{ display: 'block', mt: 2, color: 'text.secondary', fontWeight: 'bold' }}>ADDITIONAL CHARGES (Optional)</Typography>
                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                        <TextField label="Charge Label (e.g. Loading)" size="small" fullWidth value={tempProduct.extraLabel || ""} onChange={(e) => handleTempChange("extraLabel", e.target.value)} />
                        <TextField label="Amount" size="small" type="number" sx={{ width: '150px' }} value={tempProduct.extraAmount || 0} onChange={(e) => handleTempChange("extraAmount", e.target.value)} />
                    </Box>
                    <TextField fullWidth size='small' label="Total Amount" type="number" sx={{ mt: 3, bgcolor: '#f0f7ff' }} value={tempProduct.amount} disabled InputProps={{ startAdornment: <Typography sx={{ mr: 1, fontWeight: 'bold' }}>₹</Typography>, }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenProductDialog(false)}>Cancel</Button>
                    <Button variant="contained" onClick={addProductFromPopup}>Add Product</Button>
                </DialogActions>
            </Dialog>

            <div id="a4-print-wrap">
                {printData && (
                    <div className="a4-receipt">
                        <div className="header-modern-centered">
                            <h1>Vishwajeet Khadi Kendra Kendra<span className="highlight"> </span></h1>
                            <p className="subtitle">Dharashiv, Maharashtra | Mo. +91 94225 76757</p>
                        </div>
                        <div className="ticket-bar">
                            <div className="bar-item">
                                <strong>TICKET NO:</strong> #{printData.ticketNo} <br />
                                <strong>Chalan NO:</strong> #{printData.challan}
                            </div>
                            <div className="bar-item">
                                <strong>DATE:</strong> {printData.grossDate?.toDate().toLocaleDateString()}
                            </div>
                        </div>
                        <div className="info-grid">
                            <div className="info-card">
                                <label>CUSTOMER DETAILS</label>
                                <p><strong>{printData.customerName}</strong></p>
                                <p>{printData.mobile || "N/A"}</p>
                            </div>
                            <div className="info-card">
                                <label>VEHICLE DETAILS</label>
                                <p><strong>{printData.vehicleNo}</strong></p>
                                <p>{printData.wbName || "Vishwajeet Khadi Kendra Bridge"}</p>
                            </div>
                            <div className="info-card">
                                <label>WEIGHT SUMMARY</label>
                                <div className="weight-row"><span>Gross:</span> <b>{printData.grossWeight} kg</b></div>
                                <div className="weight-row"><span>Tare:</span> <b>{printData.tareWeight} kg</b></div>
                                <div className="weight-row net"><span>Net Weight:</span> <b>{printData.netWeight} kg</b></div>
                            </div>
                        </div>
                        <table className="modern-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th style={{ textAlign: 'left' }}>Product Description</th>
                                    <th>Qty / Brass</th>
                                    <th>Rate (₹)</th>
                                    <th>Total (₹)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {printData.products?.map((p, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td style={{ textAlign: 'left' }}>{p.productName}</td>
                                        <td>{p.qty || p.brass || 0}</td>
                                        <td>{Number(p.rate).toLocaleString("en-IN")}</td>
                                        <td>{Number(p.amount).toLocaleString("en-IN")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="grand-total-container">
                            <div className="total-label">GRAND TOTAL</div>
                            <div className="total-amount">₹ {Number(printData.totalAmount || 0).toLocaleString("en-IN")}</div>
                        </div>
                        <div className="photo-evidence-section">
                            <h3 className="section-title">WEIGHMENT EVIDENCE (CAM PHOTOS)</h3>
                            <div className="photo-grid">
                                {printData.tarePhotos?.map((img, idx) => (
                                    <div className="photo-box" key={`tare-${idx}`}>
                                        <img src={img} alt="Tare" />
                                        <span>TARE - CAM {idx + 1}</span>
                                    </div>
                                ))}
                                {printData.grossPhotos?.map((img, idx) => (
                                    <div className="photo-box" key={`gross-${idx}`}>
                                        <img src={img} alt="Gross" />
                                        <span>GROSS - CAM {idx + 1}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="sign-bar">
                            <div className="bar-item"><strong>Receiver Signature</strong></div>
                            <div className="bar-item"><strong>Matohshi Infra Dharashiv Pvt.Ltd</strong></div>
                        </div>
                    </div>
                )}
            </div>

            <style>{`
#a4-print-wrap { display: none; }
@media print {
  @page { size: A4; margin: 0; }
  html, body { width: 1005px; margin: 0 !important; background: #fff; }
  body * { visibility: hidden; }
  #a4-print-wrap, #a4-print-wrap * { visibility: visible; }
  #a4-print-wrap { display: block !important; position: absolute; top: 0; left: 0; width: 1005px; }
  .a4-receipt { width: 1005px; height: auto; padding: 20px; box-sizing: border-box; overflow: hidden; font-family: 'Segoe UI', Roboto, sans-serif; color: #333; }
  .header-modern-centered { text-align: center; border-bottom: 2px solid #1a237e; padding-bottom: 15px; margin-bottom: 15px; }
  .header-modern-centered h1 { margin: 0; font-size: 28px; color: #1a237e; }
  .highlight { color: #ffab00; }
  .subtitle { margin: 5px 0 0; color: #666; font-size: 16px; }
  .ticket-bar { display: flex; justify-content: space-between; background: #f5f5f5 !important; padding: 10px 15px; border-radius: 6px; margin-bottom: 15px; border: 1px solid #ddd; font-size: 17px; }
  .sign-bar { display: flex; justify-content: space-between; padding: 40px 75px; border-radius: 6px; margin-bottom: 15px; font-size: 17px; margin-top:100px; }
  .info-grid { display: grid; grid-template-columns: 1fr 1fr 1.2fr; gap: 15px; margin-bottom: 20px; }
  .info-card { padding: 12px; background: #fafafa !important; border-radius: 8px; border-left: 4px solid #1a237e; }
  .info-card label { font-size: 15px; font-weight: bold; color: #1a237e; display: block; margin-bottom: 4px; }
  .info-card p { margin: 0; font-size: 17px; }
  .weight-row { display: flex; justify-content: space-between; font-size: 16px; }
  .net { border-top: 1px solid #ddd; margin-top: 5px; padding-top: 5px; color: #d32f2f; font-size: 17px; }
  .modern-table { width: 100%; border-collapse: collapse; }
  .modern-table th { background: #1a237e !important; color: white !important; padding: 10px; font-size: 16px; }
  .modern-table td { padding: 10px; border-bottom: 1px solid #eee; font-size: 16px; text-align: center; }
  .grand-total-container { margin-top: 15px; padding: 12px 20px; background: #1a237e !important; color: white !important; border-radius: 8px; display: flex; justify-content: flex-end; align-items: center; gap: 20px; }
  .total-amount { font-size: 20px; font-weight: bold; }
  .photo-evidence-section { margin-top: 20px; page-break-inside: avoid; }
  .section-title { font-size: 14px; color: #1a237e; border-bottom: 1px solid #ddd; padding-bottom: 5px; }
  .photo-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-top: 10px; }
  .photo-box img { width: 100%; height: 210px; object-fit: cover; border-radius: 4px; border: 1px solid #ddd; }
  .photo-box span { font-size: 12px; display: block; margin-top: 3px; color: #666; font-weight: bold; }
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
}
`}</style>
        </Box >
    );
};

export default WeighbridgeSoftware;